export default "__VITE_ASSET__2U8w8dhL__"